/* Box90 — troca a oferta das tags dos cards a cada N segundos, sincronizada pelo relógio (todas as tags da página mudam juntas). */
(function () {
  if (window.__b90Tag) return;
  window.__b90Tag = true;

  function intervalo() {
    var t = document.querySelector('[data-b90-tag]');
    var s = t ? parseFloat(t.getAttribute('data-intervalo')) : 3;
    return (isNaN(s) || s < 1 ? 3 : s) * 1000;
  }

  function aplicar(semAnimacao) {
    var ms = intervalo();
    var idx = Math.floor(Date.now() / ms);
    document.querySelectorAll('[data-b90-tag]').forEach(function (tag) {
      var itens = tag.querySelectorAll('.b90-tag__item');
      if (itens.length < 2) return;
      var alvo = itens[idx % itens.length];
      if (alvo.classList.contains('is-ativa')) return;
      if (semAnimacao) tag.classList.add('b90-tag--sem-transicao');
      itens.forEach(function (i) {
        if (i === alvo) return;
        if (i.classList.contains('is-ativa')) {
          i.classList.remove('is-ativa');
          if (!semAnimacao) {
            i.classList.add('is-saindo');
            setTimeout(function () { i.classList.remove('is-saindo'); }, 520);
          }
        } else {
          i.classList.remove('is-saindo');
        }
      });
      alvo.classList.add('is-ativa');
      if (semAnimacao) requestAnimationFrame(function () { requestAnimationFrame(function () { tag.classList.remove('b90-tag--sem-transicao'); }); });
    });
  }

  function agendar() {
    var ms = intervalo();
    setTimeout(function () { aplicar(false); agendar(); }, ms - (Date.now() % ms) + 30);
  }

  function iniciar() { aplicar(true); agendar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
